import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { ANALYTICS_SUB_SUITE_IDS } from 'reporting-discover-components/constants/AnalyticsSubSuiteIds';
import { ANALYTICS_SUITE_IDS } from '../constants/templates';
const portalId = PortalIdParser.get();
export const SUITE_LEARNING_RESOURCES = {
  [ANALYTICS_SUITE_IDS.MARKETING]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.metrics',
    path: 'https://blog.hubspot.com/customers/marketing-metrics-to-know'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.understandingReporting',
    path: `/academy/${portalId}?overviewType=LESSON&overviewEntityId=${enviro.isProd() ? '3716245' : '40029515'}`
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.howToBuild',
    path: 'https://blog.hubspot.com/marketing/running-marketing-reports-ht'
  }],
  [ANALYTICS_SUB_SUITE_IDS.ADVANCED_MARKETING_REPORTING]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.advancedReporting.journey',
    path: 'https://knowledge.hubspot.com/reports/create-a-journey-report'
  }],
  [ANALYTICS_SUB_SUITE_IDS.CHANNEL_PERFORMANCE]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.channelPerformance.adTracking',
    path: 'https://knowledge.hubspot.com/ads/troubleshoot-ad-tracking-issues'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.channelPerformance.manageForms',
    path: 'https://knowledge.hubspot.com/forms/manage-your-forms'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.channelPerformance.createCtas',
    path: 'https://knowledge.hubspot.com/ctas/create-calls-to-action'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.channelPerformance.analyzeEmails',
    path: 'https://knowledge.hubspot.com/marketing-email/analyze-your-marketing-email-campaign-performance'
  }],
  [ANALYTICS_SUB_SUITE_IDS.WEB_TRAFFIC_ANALYSIS]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.webTraffic.trackingCode',
    path: 'https://knowledge.hubspot.com/reports/install-the-hubspot-tracking-code'
  }],
  [ANALYTICS_SUB_SUITE_IDS.CRM_INSIGHTS]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.crmInsights.recordOwnership',
    path: 'https://knowledge.hubspot.com/records/how-to-set-a-record-owner'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.crmInsights.editProperties',
    path: 'https://knowledge.hubspot.com/properties/create-and-edit-properties'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.marketing.crmInsights.sourceProperties',
    path: 'https://knowledge.hubspot.com/records/update-and-filter-contacts-using-traffic-source-properties#manually-update-a-contact-s-original-or-latest-source-value'
  }],
  [ANALYTICS_SUITE_IDS.SALES]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.createSalesReports',
    path: 'https://knowledge.hubspot.com/reports/create-sales-reports-with-the-sales-reports-analytics-tool'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.createReportWithJourneyAnalytics',
    path: 'https://knowledge.hubspot.com/reports/create-a-journey-report'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.metrics',
    path: 'https://blog.hubspot.com/sales/sales-metrics'
  }],
  [ANALYTICS_SUB_SUITE_IDS.ACTIVITIES_AND_LEADS]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.coachReps.customOutcomes',
    path: 'https://knowledge.hubspot.com/calling/create-custom-call-and-meeting-outcomes'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.coachReps.createChat',
    path: 'https://knowledge.hubspot.com/chatflows/create-a-live-chat'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.coachReps.prospectingTool',
    path: 'https://knowledge.hubspot.com/prospecting/use-the-prospecting-workspace'
  }],
  [ANALYTICS_SUB_SUITE_IDS.FORECAST_AND_REVENUE]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.forecastsPipelines.createGoals',
    path: 'https://knowledge.hubspot.com/reports/create-sales-goals'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.forecastsPipelines.customizePipeline',
    path: 'https://knowledge.hubspot.com/object-settings/set-up-and-customize-your-deal-pipelines-and-deal-stages'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.forecastsPipelines.forecastSetup',
    path: 'https://knowledge.hubspot.com/forecast/set-up-the-forecast-tool'
  }, {
    title: 'reports.collectionHomes.sideWidget.learningResources.sales.forecastsPipelines.forecastTool',
    path: 'https://knowledge.hubspot.com/forecast/use-the-forecast-tool'
  }],
  [ANALYTICS_SUITE_IDS.SERVICE]: [{
    title: 'reports.collectionHomes.sideWidget.learningResources.service.createServiceReports',
    path: 'https://knowledge.hubspot.com/reports/create-service-reports-service-analytics-tool'
  }]
};
const KNOWLEDGE_BASE_REGEX = /knowledge.hubspot.com/;
export const isKnowledgeBaseResource = resource => KNOWLEDGE_BASE_REGEX.test(resource.path);